import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './Components/SideBar';
import { SidebarProvider } from './SidebarContext';
import Login from './Components/Login';
import { ToastContainer } from 'react-toastify';
import AddCategory from './Components/AddCategory';
import ListHomeCategory from './Components/ListHomeCategory';
import AddFeatureCategory from './Components/CategoryFeatured/AddFeaturedCategory';
import ListFeaturedHomeCategory from './Components/CategoryFeatured/ListFeaturedHomeCategory';
import AddDeveloperCategory from './Components/CategoryDeveloper/AddDeveloperCategory';
import ListDeveloperHomeCategory from './Components/CategoryDeveloper/ListDeveloperHomeCategory';
import Slider from './Components/Slider';
import PropertyCategory from './Components/PropertyCategory';
import PropertyForm from './Components/PropertyForm';
import MyProperty from './Components/MyProperty';
import Amenities from './Components/Amenities';
import LocationAdvantage from './Components/LocationAdvantage';
import ProtectedRoute from './Components/ProtectedRoute';
import NotFound from './Components/NotFound';
import Slider2 from './Components/Slider2'
import PropertyCategoryUpdate from './Components/PropertyCategoryUpdated';
import MyProjectUpdated from './Components/MyProjectUpdated';
import AmenitiesUpdatedTable from './Components/AmenitiesUpdatedTable';
import LocationAdvantageUpdated from './Components/LocationAdvantageUpdated';
import WaterSupply from './Components/WaterSupply';
import Security from './Components/Security';
import ResidentPropertyForm from './Components/ResidentPropertyForm';
import RentPropertyForm from './Components/RentPropertyForm';
import CommercialPropertyForm from './Components/CommercialPropertyForm';
import ResidentPropertyEdit from './Components/ResidentPropertyEdit';
import ResidentRentEdit from './Components/RentResidential';
import CommercialEdit from './Components/CommercialEdit';
import Feedback from './Components/Feedback';
import Schedule from './Components/Schedule';
import Marquee from './Components/Marquee/Marquee';
import ResetPassword from './Components/ResetPassword';
import Contact from './Components/Contact';
import Events from './Components/Events/Events';

const App = () => {
    const location = useLocation();
    const login = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh"));
    const userLoggedIn = login && login.user_id;
    const hideSidebarRoutes = ['/login', '/register'];
    const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname) || !userLoggedIn;
    return (
        <SidebarProvider>
            <div className="app-container">
                {/* Sidebar is always rendered */}
                {!shouldHideSidebar && <Sidebar />}
                {/* Main content area */}
                <div className={`main-content ${shouldHideSidebar ? 'full-width' : ''}`}>
                    <Routes>


                        <Route path="/login" element={<Login />} />

                        <Route path="/addcategory" element={<ProtectedRoute><AddCategory /></ProtectedRoute>} />
                        <Route path="/addpropertycategory/:id" element={<ProtectedRoute><ListHomeCategory /></ProtectedRoute>} />
                        <Route path="/addfeaturedcategory" element={<ProtectedRoute><AddFeatureCategory /></ProtectedRoute>} />
                        <Route path="/addpropertyfeaturecategory/:id" element={<ProtectedRoute><ListFeaturedHomeCategory /></ProtectedRoute>} />
                        <Route path="/adddeveloper" element={<ProtectedRoute><AddDeveloperCategory /></ProtectedRoute>} />
                        <Route path="/adddeveloper/:id" element={<ProtectedRoute><ListDeveloperHomeCategory /></ProtectedRoute>} />
                        {/* <Route path="/slider" element={<ProtectedRoute><Slider /></ProtectedRoute>} /> */}
                        <Route path="/slider-2" element={<ProtectedRoute><Slider2 /></ProtectedRoute>} />
                        <Route path="/propertyCategory" element={<ProtectedRoute><PropertyCategory /></ProtectedRoute>} />
                        <Route path="/propertyCategory-2" element={<ProtectedRoute><PropertyCategoryUpdate /></ProtectedRoute>} />
                        <Route path="/addproperty" element={<ProtectedRoute><PropertyForm /></ProtectedRoute>} />
                        <Route path="/resident-property/:id" element={<ProtectedRoute><ResidentPropertyEdit /></ProtectedRoute>} />
                        <Route path="/rent-addproperty/:id" element={<ProtectedRoute><ResidentRentEdit /></ProtectedRoute>} />
                        <Route path="/commercial-addproperty/:id" element={<ProtectedRoute><CommercialEdit /></ProtectedRoute>} />
                        <Route path="/feedback" element={<ProtectedRoute><Feedback /></ProtectedRoute>} />
                        <Route path="/schedule" element={<ProtectedRoute><Schedule /></ProtectedRoute>} />
                        <Route path="/resident-addproperty" element={<ProtectedRoute><ResidentPropertyForm /></ProtectedRoute>} />
                        <Route path="/rent-addproperty" element={<ProtectedRoute><RentPropertyForm /></ProtectedRoute>} />
                        <Route path="/commercial-addproperty" element={<ProtectedRoute><CommercialPropertyForm /></ProtectedRoute>} />
                        <Route path="/property" element={<ProtectedRoute><MyProperty /></ProtectedRoute>} />
                        <Route path="/" element={<ProtectedRoute><MyProjectUpdated /></ProtectedRoute>} />
                        <Route path="/amenities" element={<ProtectedRoute><Amenities /></ProtectedRoute>} />
                        <Route path="/amenities-2" element={<ProtectedRoute><AmenitiesUpdatedTable /></ProtectedRoute>} />
                        <Route path="/location-advantage" element={<ProtectedRoute><LocationAdvantage /></ProtectedRoute>} />
                        <Route path="/location-advantage-2" element={<ProtectedRoute><LocationAdvantageUpdated /></ProtectedRoute>} />
                        <Route path="/water-supply" element={<ProtectedRoute><WaterSupply /></ProtectedRoute>} />
                        <Route path="/marquee" element={<ProtectedRoute><Marquee /></ProtectedRoute>} />
                        <Route path="/security" element={<ProtectedRoute><Security /></ProtectedRoute>} />
                        <Route path="/contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />
                        <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />


                        <Route path="/reset" element={<ResetPassword />} />


                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>

            </div>
            <ToastContainer position="top-right" autoClose={3000} style={{ zIndex: 999999 }} />
        </SidebarProvider>
    );
};

export default App;
